import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useConfig} from './config'
import {
  setPersonaSidebarOpen,
  setPersonas,
  setSelectedPersonas,
  setPersonasToggle,
  selectPersonaSidebarOpen,
  selectPersonas,
  selectSelectedPersonas,
  selectPersonasToggle
} from '../slices/personaSlice'

export const usePersona = () => {
  const dispatch = useDispatch()
  const {personasConfig} = useConfig()

  const personaSidebarOpen = useSelector(selectPersonaSidebarOpen)
  const personas = useSelector(selectPersonas)
  const selectedPersonas = useSelector(selectSelectedPersonas)
  const personasToggle = useSelector(selectPersonasToggle)

  // Initialize personas with config only when empty
  useEffect(() => {
    if (personasConfig?.personas && personas.length === 0) {
      const configPersonas = Object.keys(personasConfig.personas)
      dispatch(setPersonas(configPersonas))
      dispatch(setSelectedPersonas(configPersonas))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personasConfig, dispatch])

  // Return the same API as the original provider
  return {
    personaSidebarOpen,
    setPersonaSidebarOpen: (value) => dispatch(setPersonaSidebarOpen(value)),
    personas,
    setPersonas: (value) => dispatch(setPersonas(value)),
    personasToggle,
    setPersonasToggle: (value) => dispatch(setPersonasToggle(value)),
    selectedPersonas,
    setSelectedPersonas: (value) => dispatch(setSelectedPersonas(value))
  }
}
